// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-nav-trigger{top:-94px !important}@media screen and (min-width: 576px){.category-nav-trigger{top:-58px !important}}", ""]);
// Exports
module.exports = exports;
